
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/watch/dry-bar-best-of",
      function () {
        return require("private-next-pages/[locale]/watch/dry-bar-best-of.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/watch/dry-bar-best-of"])
      });
    }
  